import { render, staticRenderFns } from "./WidgetsInput.vue?vue&type=template&id=c4d6beaa&scoped=true"
import script from "./WidgetsInput.vue?vue&type=script&lang=js"
export * from "./WidgetsInput.vue?vue&type=script&lang=js"
import style0 from "./WidgetsInput.vue?vue&type=style&index=0&id=c4d6beaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d6beaa",
  null
  
)

export default component.exports